import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SliderHeader from 'components/products-slider-header';
import Icon from 'components/icon';
import { Trans } from 'translations';
import normaliseTrailingSlash from 'util/misc/normalise-trailing-slash';
import { Link } from 'react-router-dom';
import classnames from 'classnames';


export default class EmptyCategorySlider extends Component {
    static propTypes = {
        icon_key: PropTypes.string,
        title: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
        link_label_key: PropTypes.string.isRequired,
        header_link_label_key: PropTypes.string.isRequired,
        show_description: PropTypes.bool,
    };

    static defaultProps = {
        show_description: true,
    };

    render() {
        const { title, link, link_label_key, icon_key, show_description, header_link_label_key } = this.props;

        return (
            <div
                className={ classnames('empty-category-slider', show_description ? null : 'empty-category-slider__loading') }>
                { title && <SliderHeader title={ title } link={ link } link_label_key={ header_link_label_key }/> }
                <div className="empty-category-slider--content-wrapper">
                    <div className="empty-category-slider--content">
                        <Icon className="empty-category-slider--icon" symbol={ icon_key } size="large"/>
                        { show_description && <p className="u-reset empty-category-slider--description">
                            <Trans path='mymigros.no_products_in_category'/>
                        </p> }
                        { show_description &&
                        <Link
                            className="empty-category-slider--link u-reset"
                            to={ normaliseTrailingSlash(link) }
                        >
                            <Trans path={ link_label_key }/>
                        </Link>
                        }
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/mymigros-sliders/empty-category-slider/index.js